import { ActionType } from '@editor/src/js/constants/common-action-type';
import { PresetChartType } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/const';
import {
    ChartModelFactory,
} from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/chart-model-factory';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import type { IMenuEventParams } from '@src/slide/application/service/menu-manager/menu-event/menu-event.interface';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import type { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import type { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { ChartActionType } from '@src/slide/domain/ui-model/element-modeles/property/chart/constant';

export const modifyChartTypeMap: Record<string, PresetChartType> = {
    [ActionType.MODIFY_CHART_TYPE_TO_COLUMN_CLUSTERED]: PresetChartType.COLUMN_CLUSTERED,
    [ActionType.MODIFY_CHART_TYPE_TO_COLUMN_STACKED]: PresetChartType.COLUMN_STACKED,
    [ActionType.MODIFY_CHART_TYPE_TO_COLUMN_PERCENT_STACKED]: PresetChartType.COLUMN_PERCENT_STACKED,

    [ActionType.MODIFY_CHART_TYPE_TO_BAR_CLUSTERED]: PresetChartType.BAR_CLUSTERED,
    [ActionType.MODIFY_CHART_TYPE_TO_BAR_STACKED]: PresetChartType.BAR_STACKED,
    [ActionType.MODIFY_CHART_TYPE_TO_BAR_PERCENT_STACKED]: PresetChartType.BAR_PERCENT_STACKED,

    [ActionType.MODIFY_CHART_TYPE_TO_LINE_STANDARD]: PresetChartType.LINE_STANDARD,
    [ActionType.MODIFY_CHART_TYPE_TO_LINE_STACKED]: PresetChartType.LINE_STACKED,
    [ActionType.MODIFY_CHART_TYPE_TO_LINE_PERCENT_STACKED]: PresetChartType.LINE_PERCENT_STACKED,
    [ActionType.MODIFY_CHART_TYPE_TO_LINE_STANDARD_WITH_POINT]: PresetChartType.LINE_STANDARD_WITH_POINT,
    [ActionType.MODIFY_CHART_TYPE_TO_LINE_STACKED_WITH_POINT]: PresetChartType.LINE_STACKED_WITH_POINT,
    [ActionType.MODIFY_CHART_TYPE_TO_LINE_PERCENT_STACKED_WITH_POINT]: PresetChartType.LINE_PERCENT_STACKED_WITH_POINT,

    [ActionType.MODIFY_CHART_TYPE_TO_PIE]: PresetChartType.PIE,
    [ActionType.MODIFY_CHART_TYPE_TO_OF_PIE]: PresetChartType.OF_PIE,
    [ActionType.MODIFY_CHART_TYPE_TO_OF_PIE_BAR]: PresetChartType.OF_PIE_BAR,
    [ActionType.MODIFY_CHART_TYPE_TO_DOUGHNUT]: PresetChartType.DOUGHNUT,

    [ActionType.MODIFY_CHART_TYPE_TO_AREA]: PresetChartType.AREA,
    [ActionType.MODIFY_CHART_TYPE_TO_AREA_STACKED]: PresetChartType.AREA_STACKED,
    [ActionType.MODIFY_CHART_TYPE_TO_AREA_PERCENT_STACKED]: PresetChartType.AREA_PERCENT_STACKED,

    [ActionType.MODIFY_CHART_TYPE_TO_RADAR]: PresetChartType.RADAR,
    [ActionType.MODIFY_CHART_TYPE_TO_RADAR_WITH_FILL]: PresetChartType.RADAR_WITH_FILL,
    [ActionType.MODIFY_CHART_TYPE_TO_RADAR_WITH_POINT]: PresetChartType.RADAR_WITH_POINT,
};

export const chartActionTypeMapping = {
    [ActionType.FONT]: ChartActionType.FONTFAMILY,
    [ActionType.FONTSIZE]: ChartActionType.FONT_SIZE,
    [ActionType.FONTSIZE_UP]: ChartActionType.FONT_SIZE_UP,
    [ActionType.FONTSIZE_DOWN]: ChartActionType.FONT_SIZE_DOWN,
    [ActionType.BOLD]: ChartActionType.BOLD,
    [ActionType.ITALIC]: ChartActionType.ITALIC,
    [ActionType.FORECOLOR]: ChartActionType.FONT_COLOR,
    // ActionType.BACKCOLOR,
    // ActionType.UNDERLINE,
    // ActionType.DELETELINE,
    // ActionType.SUBSCRIPT,
    // ActionType.SUPERSCRIPT,
};

export function handleMenuEvent(model: IChartModel, menuEventParams: IMenuEventParams): boolean {
    const { actionType, values } = menuEventParams;

    if (modifyChartTypeMap[actionType] !== undefined) {
        ChartModelFactory.modifyChartType(model, modifyChartTypeMap[actionType]);

        return true;
    }
    if (actionType === ActionType.EDIT_CHART_DATA) {
        (getAppServices() as IPcEditorAppServices).editableServiceLayer?.chartManager.openChartDataEditor(model);
        return true;
    }

    if (Object.keys(chartActionTypeMapping).includes(actionType)) {
        model.chartProperty.updateEditingSelectTextStyle(chartActionTypeMapping[actionType], values);
    }

    return false;
}

function getAppServices(): IEditorAppServices {
    return AppServiceProvider.getInstance()
        .getAppServices() as IEditorAppServices;
}
